import { Stack } from '@mui/material';
import { SelectFormField, TextFormField } from 'components/Forms/FormFields';
import CurrencyFormField from 'components/Forms/FormFields/CurrencyFormField/CurrencyFormField';

export default function AddAccountEntryForm() {
    return (
        <Stack spacing={3}>
            <CurrencyFormField
                label="Valor solicitado"
                fullWidth
                name="valueInCents"
                variant="outlined"
                required
            />
            <TextFormField
                name="commentsDoc"
                fullWidth
                label="Documento"
                variant="outlined"
                required
            />
            <TextFormField
                name="complement"
                fullWidth
                label="Complemento"
                variant="outlined"
                required
            />
            <SelectFormField
                name="accountEntryType"
                variant="outlined"
                label="Tipo de lançamento"
                fullWidth
                required
                options={[
                    { label: "Pix Enviado", value: "PixSent" },
                    { label: "Estorno de Pix Enviado", value: "PixReservalSent" },
                    { label: "Devolução de Pix Enviado", value: "PixRefundSent" },
                    { label: "Pix Recebido", value: "PixReceived" },
                    { label: "Devolução de Pix Recebido", value: "PixRefundReceived" },
                    { label: "Estorno de Devolução do Pix Recebido", value: "PixReversalRefundReceived" },
                    { label: "Bloqueio de Saldo", value: "BlockBalance" },
                    { label: "Débito Simples", value: "EntryDebit" },
                    { label: "Crédito Simples", value: "EntryCredit" },
                    { label: "Depósito por Boleto", value: "DepositByBankSlip" },
                    { label: "Tarifa de Processamento", value: "BillingFee" },
                    { label: "Pagamento de Boleto", value: "PaymentBankSlip" },
                    { label: "Debito de Transferencia", value: "TransferDebit" },
                    { label: "Despesas operacionais", value: "AdministrativeExpenses" },
                    { label: "Tarifa Pix", value: "PixFare" }
                  ]}
            />
        </Stack>
    );
}
